export default __webpack_public_path__ + "static/media/signinEmploye.0c150072.png";